export default class Player {
	constructor() {
		this.init();
	}

	init() {
		let slideWrapper = jQuery('.artist__slider'),
			iframes = slideWrapper.find('.video-wrapper iframe'),
			lazyImages = slideWrapper.find('.image img'),
			self = this;

		this.slideWrapper = slideWrapper;
		this.iframes = iframes;
		this.lazyImages = lazyImages;

		this.loadScript();

		jQuery(window).on('resize.slickVideoPlayer', function() {
			self.resizePlayer(iframes, 16 / 9);
		});
	}

	loadScript() {
		let lazyCounter = 0,
			self = this;

		// Initialize
		this.slideWrapper.on('init', function(slick) {
			slick = jQuery(slick.currentTarget);
			setTimeout(function() {
				self.playPauseVideo(slick, 'play');
			}, 1000);
			self.resizePlayer(self.iframes, 16 / 9);
		});
		this.slideWrapper.on('beforeChange', function(event, slick) {
			slick = jQuery(slick.$slider);
			self.playPauseVideo(slick, 'pause');
		});
		this.slideWrapper.on('afterChange', function(event, slick) {
			slick = jQuery(slick.$slider);
			self.playPauseVideo(slick, 'play');
		});
		this.slideWrapper.on('lazyLoaded', function(
			event,
			slick,
			image,
			imageSource,
		) {
			lazyCounter++;
			if (lazyCounter === this.lazyImages.length) {
				this.lazyImages.addClass('show');
				// slideWrapper.slick("slickPlay");
			}
		});

		//start the slider
		this.slideWrapper.slick({
			// fade:true,
			autoplaySpeed: 4000,
			lazyLoad: 'ondemand',
			speed: 600,
			arrows: true,
			dots: false,
			prevArrow: '<span class="artist__arrow artist__arrow--prev"></span>',
			nextArrow: '<span class="artist__arrow artist__arrow--next"></span>',
			cssEase: 'cubic-bezier(0.87, 0.03, 0.41, 0.9)',
			responsive: [
				{
					breakpoint: 600,
					settings: {
						arrows: true,
						// infinite: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						pauseOnFocus: false,
						pauseOnHover: false,
					},
				},
			],
		});
		// jQuery('.artist__slider')
		// 	.not('.slick-initialized')
		// 	.slick({
		// 		adaptiveHeight: false,
		// 		variableWidth: false,
		// 		lazyLoad:'progressive',
		// 		speed:600,
		// 		autoplaySpeed:4000,
		// 		slidesToShow: 1,
		// 		slidesToScroll: 1,
		// 		autoplay: true,
		// 		dots: false,
		// 		arrows: true,
		// 		infinite: true,
		// 		centerMode: true,
		// 		centerPadding: '0px',
		// 		rows: 0,
		// 		pauseOnFocus: true,
		// 		pauseOnHover: true,
		// 		prevArrow: '<span class="artist__arrow artist__arrow--prev"></span>',
		// 		nextArrow: '<span class="artist__arrow artist__arrow--next"></span>',
		// 		responsive: [
		// 			{
		// 				breakpoint: 600,
		// 				settings: {
		// 					dots: false,
		// 					arrows: false,
		// 					infinite: true,
		// 					slidesToShow: 1,
		// 					slidesToScroll: 1,
		// 					pauseOnFocus: true,
		// 					pauseOnHover: true,
		// 				},
		// 			},
		// 			{
		// 				breakpoint: 800,
		// 				settings: {
		// 					dots: true,
		// 					arrows: true,
		// 					infinite: true,
		// 					slidesToShow: 1,
		// 					slidesToScroll: 1,
		// 					pauseOnFocus: true,
		// 					pauseOnHover: true,
		// 				},
		// 			},
		// 		],
		// 	});
	}

	// POST commands to YouTube or Vimeo API
	postMessageToPlayer(player, command) {
		if (null == player || null == command) return;
		player.contentWindow.postMessage(JSON.stringify(command), '*');
	}

	// When the slide is changing
	playPauseVideo(slick, control) {
		console.log('playPauseVideo');

		let currentSlide, slideType, startTime, player, video;

		currentSlide = slick.find('.slick-current');
		slideType = currentSlide.attr('class').split(' ')[1];
		player = currentSlide.find('iframe').get(0);
		startTime = currentSlide.data('video-start');

		if ('vimeo' === slideType) {
			switch (control) {
			case 'play':
				if (
					null != startTime &&
						0 < startTime &&
						!currentSlide.hasClass('started')
				) {
					currentSlide.addClass('started');
					postMessageToPlayer(player, {
						method: 'setCurrentTime',
						value: startTime,
					});
				}
				postMessageToPlayer(player, {
					method: 'play',
					value: 1,
				});
				break;
			case 'pause':
				postMessageToPlayer(player, {
					method: 'pause',
					value: 1,
				});
				break;
			}
		} else if ('youtube' === slideType) {
			switch (control) {
			case 'play':
				postMessageToPlayer(player, {
					event: 'command',
					func: 'mute',
				});
				postMessageToPlayer(player, {
					event: 'command',
					func: 'playVideo',
				});
				break;
			case 'pause':
				postMessageToPlayer(player, {
					event: 'command',
					func: 'pauseVideo',
				});
				break;
			}
		} else if ('video' === slideType) {
			video = currentSlide.children('video').get(0);
			if (null != video) {
				if ('play' === control) {
					video.play();
				} else {
					video.pause();
				}
			}
		}
	}

	// Resize player
	resizePlayer(iframes, ratio) {
		if (!iframes[0]) return;
		let win = jQuery('.main-slider'),
			width = win.width(),
			playerWidth,
			height = win.height(),
			playerHeight;

		ratio = ratio || 16 / 9;

		iframes.each(function() {
			let current = jQuery(this);
			if (width / ratio < height) {
				playerWidth = Math.ceil(height * ratio);
				current
					.width(playerWidth)
					.height(height)
					.css({
						left: (width - playerWidth) / 2,
						top: 0,
					});
			} else {
				playerHeight = Math.ceil(width / ratio);
				current
					.width(width)
					.height(playerHeight)
					.css({
						left: 0,
						top: (height - playerHeight) / 2,
					});
			}
		});
	}
}
